import { TooltipWrapper } from 'components/TooltipWrapper';
import { ActKc3LevelEnum } from 'gql/graphql';
import { Select, IconQuestion } from 'uikit';

import type React from 'react';
import { useCallback, useMemo } from 'react';

import Style from './ActKC3LevelSelect.module.css';

interface IActKC3LevelSelect {
    actKC3Level?: ActKc3LevelEnum;
    onChange: (value: ActKc3LevelEnum) => void;
    unableSelection?: boolean;
}

const selectItems = [
    {
        id: ActKc3LevelEnum.Contract,
        label: 'Договор',
    },
    {
        id: ActKc3LevelEnum.WorkOrder,
        label: 'Наряд-Заказ',
    },
    {
        id: ActKc3LevelEnum.Object,
        label: 'Объект',
    },
];

const getItemLabel = (i: (typeof selectItems)[0]) => i.label;
const getItemKey = (i: (typeof selectItems)[0]) => i.id;

export const ActKC3LevelSelect: React.FC<IActKC3LevelSelect> = (props) => {
    const { actKC3Level = ActKc3LevelEnum.Contract, onChange, unableSelection } = props;

    const value = useMemo(() => selectItems.find((i) => i.id === actKC3Level), [actKC3Level]);

    const onChangeLocal = useCallback(({ value: v }) => onChange(v.id), [onChange]);

    return (
        <div className={Style.actKC3LevelSelect}>
            <div className={unableSelection ? Style.actKC3LevelUnableBlockTitle : Style.actKC3LevelSelectTitle}>
                Уровень реестра{unableSelection ? ':' : ''}
            </div>
            {!unableSelection && (
                <Select
                    items={selectItems}
                    value={value}
                    onChange={onChangeLocal}
                    getItemLabel={getItemLabel}
                    getItemKey={getItemKey}
                    className={Style.actKC3LevelSelectInput}
                />
            )}
            {unableSelection && (
                <div className={Style.actKC3LevelSelectUnableBlock}>
                    <div className={Style.actKC3LevelSelectUnableBlockValue}>{value?.label}</div>
                    <TooltipWrapper message="Для того чтобы изменить уровень формирования реестра Справок КС-3 удалите все текущие Справки">
                        <IconQuestion size="s" />
                    </TooltipWrapper>
                </div>
            )}
        </div>
    );
};

ActKC3LevelSelect.displayName = 'ActKC3LevelSelect';
